import {metaTagsAbout} from "@/content";
import {MetaTags} from "@/lib";
import ContentTitles from "@/ui/content-titles/content-titles";
import ContactUsBlock from "@/ui/contact-us-block";
import ServicesTiles from "@/ui/widgets/services-tiles";
import {GoogleServiceArea} from "@/ui/google-service-area/GoogleServiceArea";
import GoogleReviews from "@/ui/google-reviews/google-reviews";

export default function AboutPage() {
    return (
        <div className='bg-grey[50]'>
            <MetaTags metaTags={metaTagsAbout}/>
            <div className="grid">
                <div className="col-span-12">
                    <div className="py-3 px-3 md:px-0">
                        <ContentTitles
                            title="Get in touch"
                        />
                        <div className="py-5">
                            <ContactUsBlock/>
                        </div>
                    </div>
                    <div className="px-3 my-3">
                        <GoogleServiceArea/>
                    </div>
                </div>
            </div>
            <ServicesTiles/>
            <div className="mb-3">
                <GoogleReviews/>
            </div>

        </div>
    );
}
